import React, { useMemo } from 'react';
import { connectMenu } from 'react-contextmenu';

import { ContextMenu, MenuTrigger, MenuOption } from 'components/UI/context-menu/context-menu';

interface MenuData {
  id: string;
  ['data-handleCopy']: (storyId: StoryId) => void;
  ['data-handleSettings']: (storyId: StoryId) => void;
  ['data-storyId']: StoryId;
}
interface MenuModal {
  id: string;
  trigger: MenuData;
}
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  storyId: StoryId;
  handleCopy: (storyId: StoryId) => void;
  handleSettings: (storyId: StoryId) => void;
}
const MENU_ID = 'storyMenu';

// C O M P O N E N T S

export const StoryMenuContainer = ({ storyId, handleCopy, handleSettings, children, className, ...rest }: Props) => (
  <MenuTrigger
    id={MENU_ID}
    collect={(props) => props}
    data-handleCopy={handleCopy}
    data-handleSettings={handleSettings}
    data-storyId={storyId}
    attributes={{ className, style: { width: '100%' }, ...rest }}
    holdToDisplay={-1}
    mouseButton={0}
  >
    {children}
  </MenuTrigger>
);

const MenuModal = (props: MenuModal) => {
  const { id, trigger } = props;

  const payload = useMemo(() => {
    if (!trigger) return;

    return {
      handleCopy: trigger['data-handleCopy'],
      handleSettings: trigger['data-handleSettings'],
      storyId: trigger['data-storyId'],
    };
  }, [trigger]);

  const handleCopy = () => {
    if (!payload) return;
    payload.handleCopy(payload.storyId);
  };

  const handleSettings = () => {
    if (!payload) return;
    payload.handleSettings(payload.storyId);
  };

  return (
    <ContextMenu id={id}>
      <MenuOption onClick={handleCopy}>Copy</MenuOption>
      <MenuOption onClick={handleSettings}>Settings</MenuOption>
    </ContextMenu>
  );
};

export const StoryMenu = connectMenu(MENU_ID)(MenuModal);
